/*
 * Copyright (c) Nexign, JSC, 2021.
 */

/**
 *
 *
 * @author Julia Ignatieva
 * @version 1.14.0
 * @since 1.14.0
 */

export interface IWizardChangeLockValidation {
    error: string;
    isValid: boolean;
}

export enum EChangeLockOperationType {
    LOCK = 'LOCK',
    UNLOCK = 'UNLOCK',
}

export interface IWizardChangeLockStartData {
    operationType?: EChangeLockOperationType;
}
